import React from 'react';
import { Panel, Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';
import { ConfirmationButton } from '../../common/components/formControls';

const List = ({ isReadonly, enableCustomTemplates, onDelete, t, ...rest }) => {
	const columns = [
		{
			header: t('MessageTemplate_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('MessageTemplate_Subject'),
			accessor: 'subject',
			sortable: true
		},
		{
			header: t('MessageTemplate_Category'),
			accessor: 'isSystem',
			sortable: true,
			cell: (isSystem) => (isSystem ? <Label bsStyle='success'>{t('MessageTemplate_System')}</Label> : <Label bsStyle='warning'>{t('MessageTemplate_Custom')}</Label>)
		},
		{
			header: t('MessageTemplate_Enabled'),
			accessor: 'enabled',
			sortable: true,
			cell: (enabled) => (ui.formatBoolean(enabled))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => <span>
				<Link to={`/messageTemplates/${id}`} className='btn btn-teal mr-1'><FontAwesomeIcon icon={isReadonly ? faEye : faEdit} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Link>
				{!row.isSystem && <ConfirmationButton
					onConfirmation={() => onDelete(id)}
					confirmationTitle={t('MessageTemplate_DeleteConfirmationTitle')}
					confirmationMessage={t('MessageTemplate_DeleteConfirmationMessage')}
					displayType={'inline'}
					label={t('Common_Delete')}
				/>}
			</span>
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <span>
					<Link to='/messageTemplates/system/new' className='btn btn-success mr-1'>{t('MessageTemplate_NewSystem')}</Link>
					{enableCustomTemplates && <Link to='/messageTemplates/custom/new' className='btn btn-warning'>{t('MessageTemplate_NewCustom')}</Link>}
				</span>} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);